import React, { useEffect, useState } from "react";
import { Button, Input, Form, Row, Col, Spin } from "antd";
import { useStore } from "../../../../../../store";
import { contactUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import watsapp from "../../../../../../assets/images/watsapp.svg";
import phoneIc from "../../../../../../assets/images/phone.svg";
import Website from "../../../../../../assets/images/website.svg";
import mail from "../../../../../../assets/images/mail.svg";
import PhoneInput from "react-phone-number-input";
import { toast } from "react-toastify";

export default function EOW({ dataLoader, form, tabKey }) {
  const { tabData } = useStore();
  const { postLoader,  getSingleTabData  } = useTab();
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();
 const [, setLoader] = useState(dataLoader || true);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);

  const handleSave = async () => {
    setLoader(true);
    try {
      const values = await form.validateFields(); 

      console.log("Valid values:===>", values);
      await form.submit();
      setFormChanged(false);
      setLoader(false);
      await getSingleTabData(tabKey);

    } catch (errorInfo) {
      toast.error(errorInfo);
      setLoader(false);
    }
  };

  if (tabData.EXPERIENCES_OF_WORK) {
    if (dataLoader || postLoader) {
      return (
        <div className="data-loader">
          <Spin tip="Loading" size="large" />
        </div>
      );
    } else {
      return (
        <div>
          {/* <Form name={tabKey}> */}
          <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            {tabKey === contactUSkeys.eow ? (
                <Col className="gutter-row tabContent" span={15}>
                  <Form.List
                    name={contactUSkeys.eow}
                    initialValue={
                      tabData && tabData[tabKey] && tabData[tabKey].length > 0
                        ? tabData[tabKey]
                        : [""]
                    }
                  >
                    {(fields) => (
                      <div>
                        {fields.map(({ key, name, ...restField }, i) => (
                          <>
                            <Form.Item
                              {...restField}
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ minWidth: "24px" }}>
                                    <img
                                      src={phoneIc}
                                      alt="Phone"
                                      style={{ marginRight: "3px" }}
                                    />
                                  </div>
                                  Phone
                                </div>
                              }
                              labelCol={{ span: 4 }}
                              name={[name, "phone"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter phone number.",
                                },
                              ]}
                            >
                              <PhoneInput
                                className="custom-phone-input"
                                defaultCountry="GB"
                                placeholder="Enter phone number"
                                focusInputOnCountrySelection
                              />
                            </Form.Item>
                            <Form.Item
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={mail}
                                    alt="Email"
                                    style={{ marginRight: "3px" }}
                                  />
                                  Email
                                </div>
                              }
                              labelCol={{ span: 4 }}
                              {...restField}
                              name={[name, "email"]}
                              rules={[
                                {
                                  // required: true,
                                  message: "Email is required",
                                },
                                { type: "email", message: "Enter a valid email" },
                              ]}
                            >
                              <Input placeholder="Enter Email" />
                            </Form.Item>
                            <Form.Item
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={watsapp}
                                    alt="Whatsapp"
                                    style={{ marginRight: "3px" }}
                                  />
                                  Whatsapp
                                </div>
                              }
                              labelCol={{ span: 4 }}
                              {...restField}
                              name={[name, "chatNumber"]}
                              rules={[
                                { required: false },
                                {
                                  pattern: /^\d{10}$/,
                                  message:
                                    "Enter a valid 10-digit phone number",
                                },
                              ]}
                            >
                              <Input
                                type="tel"
                                maxLength={10}
                                onKeyPress={(e) => {
                                  if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                placeholder="Enter Whatsapp Number"
                              />
                            </Form.Item>
                            <Form.Item
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={Website}
                                    alt="Website"
                                    style={{ marginRight: "3px" }}
                                  />
                                  Website
                                </div>
                              }
                              labelCol={{ span: 4 }}
                              {...restField}
                              name={[name, "websiteLink"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Link is required",
                                },
                                { type: "url", message: "Enter a valid URL" },
                              ]}
                            >
                              <Input placeholder="Enter Website Link" />
                            </Form.Item>
                            <Form.Item
                              className="w-100"
                              style={{
                                display: "flex",
                                justifyContent: "end",
                              }}
                            >
                              {formChanged ? (
                                <Button
                                  className="saveBtn greenBtn"
                                  onClick={() => {
                                    handleSave();
                                  }}
                                >
                                  Save
                                </Button>
                              ) : (
                                <Button
                                  className="saveBtn greenBtn"
                                  style={{
                                    opacity: "0.5",
                                    pointerEvents: "none",
                                  }}
                                >
                                  Save
                                </Button>
                              )}
                            </Form.Item>
                          </>
                        ))}
                      </div>
                    )}
                  </Form.List>
                </Col>
            ) : (
              <></>
            )}
          </Row>
          {/* </Form> */}
        </div>
      );
    }
  } else {
    <p>No Data</p>;
  }
}
